export const PageEnum = {
  // basic login path
  BASE_LOGIN: '/login',
  // basic home path
  BASE_HOME: '/home/dashboard',
  // error page path
  ERROR_PAGE: '/exception',
  // error log page path
  ERROR_LOG_PAGE: '/error-log/list',
} as const;
export type PageEnum = (typeof PageEnum)[keyof typeof PageEnum];
export const PageWrapperFixedHeightKey = 'PageWrapperFixedHeight';
export const PageHasFooterKey = 'PageHasFooter';
